import React, { useEffect, useState } from 'react';

import { func, string } from 'prop-types';

import BusyButton from 'components/Common/Buttons/BusyButton';
import Button from 'components/Common/Buttons/ButtonV2';
import useCopyToClipboard from 'components/Common/TextCopy/useCopyToClipboard';

import { getSplitValues } from 'modules/BulkSelect/components/MatchEntriesBox/utils/getSplitValues';
import useBulkMatch from 'modules/BulkSelect/hooks/useBulkMatch';

import MatchResultsBox from './MatchResultsBox';

import s from './MatchEntriesBox.css';

const MatchEntriesBox = props => {
  const [text, setText] = useState('');
  const { description, toggleFilter, removeFilter } = props;
  const { copyToClipboard } = useCopyToClipboard({ text });
  const {
    isLoading,
    matchEntriesBoxValue: value,
    setMatchEntriesBoxValue: setValue,

    sendRequest: sendBulkMatchRequest,

    matchedCount,
    notMatchedList,
    duplicateList,
    clearMatchEntriesBox: clear,
    matchType,
  } = useBulkMatch({
    toggleFilter,
    removeFilter,
  });

  useEffect(() => {
    if (text) {
      copyToClipboard();
    }
  }, [text]);

  const submitEntries = () => {
    sendBulkMatchRequest(getSplitValues(value));
  };

  const matchResults = {
    matchedCount,
    notMatchedList,
    duplicateList,
    matchType,
  };

  return (
    <div className={s.root}>
      <div className={s.description}>{description}</div>
      <textarea
        onChange={e => {
          setValue(e.target.value);
          if (!e.target.value) {
            clear();
          }
        }}
        value={value}
        className={s.entriesListInput}
        cols="30"
        rows="10"
      />
      <div className={s.actionBar}>
        <Button
          onClick={clear}
          disabled={value.length === 0}
          variant="outlined"
        >
          Clear
        </Button>
        <BusyButton
          onClick={submitEntries}
          busy={isLoading}
          disabled={value.length === 0}
          variant="filled"
          color="primary"
          text="Generate Matches"
          busyText="Generating ..."
        />
      </div>
      <div className={s.matchResultsList}>
        <MatchResultsBox
          data={matchResults}
          actions={{
            copyList: identifierList => {
              setText(identifierList.join());
            },
          }}
        />
      </div>
    </div>
  );
};

MatchEntriesBox.propTypes = {
  description: string,
  toggleFilter: func.isRequired,
  removeFilter: func.isRequired,
};

MatchEntriesBox.defaultProps = {
  description:
    'Paste a comma or line separated list of unique identifiers (name, email, student number, SIS ID, or state ID).',
};

export default MatchEntriesBox;
